const navbar = document.querySelector('.nav-dark');
window.onscroll = () => {
  if (window.scrollY > 1) {
    navbar.classList.add('nav-scrolled');
  } else {
    navbar.classList.remove('nav-scrolled');
  }
};
